<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Talep Durum Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader, treeselect, tableheader
  },
  data() {
    return {
      title: "Talep Durum Raporu",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Raporlar",
          href: "/",
        },
        {
          text: "Talep Durum Raporu",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      Filter: {
        OrderBy: "Desc=Takipno",
        Atananbirimid: null,
        Durumid: null,
        Oncelikid: null,
        Atananpersonelid: null,
        Atanantemsilciid: null,
        Talepsahibibirimid: null,
        Olusturanid: null,
        Taleptipid: null,
        Destekoncelikid: null,
        Olusturmatarihibas: null,
        Olusturmatarihibit: null,
        Guncellemetarihibas: null,
        Guncellemetarihibit: null,
        Uygulamaid: null,
        Ucretli: null,
        Baslik:null,
        Aciklama:null,
        Tamamlananharic: null,
        Tahminibitisbas: null,
        Tahminibitisbit: null
      },
      FilterText: null,
      ModalOpen: false,
      FormDataMail:{
        To: null,
        Subject: null,
        Body: null
      },
      BildirimButton: false,
      
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE
    };
  },

  methods: {
    Get() { 
      this.FilterText = "&" + this.Filter.OrderBy

      if (this.Filter.Baslik != null && this.Filter.Baslik != ""  && 
      typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        this.FilterText += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Aciklama != null && this.Filter.Aciklama != "" && 
      typeof this.Filter.Aciklama === "string" && this.Filter.Aciklama.length > 2) {
        this.FilterText += "&Aciklama=" + this.Filter.Aciklama
      }

      if (this.Filter.Ucretli != null && this.Filter.Ucretli != "") {
        this.FilterText += "&Ucretli=" + this.Filter.Ucretli
      }
      if (this.Filter.Uygulamaid != null && this.Filter.Uygulamaid != "") {
        this.FilterText += "&Uygulamaid=" + this.Filter.Uygulamaid
      }
      if (this.Filter.Atananbirimid != null && this.Filter.Atananbirimid != "") {
        this.FilterText += "&Atananbirimid=" + this.Filter.Atananbirimid
      }
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        this.FilterText += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        this.FilterText += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Atananpersonelid != null && this.Filter.Atananpersonelid != "") {
        this.FilterText += "&Atananpersonelid=" + this.Filter.Atananpersonelid
      }
      if (this.Filter.Atanantemsilciid != null && this.Filter.Atanantemsilciid != "") {
        this.FilterText += "&Atanantemsilciid=" + this.Filter.Atanantemsilciid
      }
      if (this.Filter.Talepsahibibirimid != null && this.Filter.Talepsahibibirimid != "") {
        this.FilterText += "&Talepsahibibirimid=" + this.Filter.Talepsahibibirimid
      }
      if (this.Filter.Olusturanid != null && this.Filter.Olusturanid != "") {
        this.FilterText += "&Olusturanid=" + this.Filter.Olusturanid
      }
      if (this.Filter.Taleptipid != null && this.Filter.Taleptipid != "") {
        this.FilterText += "&Taleptipid=" + this.Filter.Taleptipid
      }
      if (this.Filter.Destekoncelikid != null && this.Filter.Destekoncelikid != "") {
        this.FilterText += "&Destekoncelikid=" + this.Filter.Destekoncelikid
      }
      if (this.Filter.Olusturmatarihibas != null && this.Filter.Olusturmatarihibas != "") {
        this.FilterText += "&Olusturmatarihibas=" + this.Filter.Olusturmatarihibas
      }
      if (this.Filter.Olusturmatarihibit != null && this.Filter.Olusturmatarihibit != "") {
        this.FilterText += "&Olusturmatarihibit=" + this.Filter.Olusturmatarihibit
      }
      if (this.Filter.Guncellemetarihibas != null && this.Filter.Guncellemetarihibas != "") {
        this.FilterText += "&Guncellemetarihibas=" + this.Filter.Guncellemetarihibas
      }

      if (this.Filter.Guncellemetarihibit != null && this.Filter.Guncellemetarihibit != "") {
        this.FilterText += "&Guncellemetarihibit=" + this.Filter.Guncellemetarihibit
      }
      if (this.Filter.Tamamlananharic != null && this.Filter.Tamamlananharic != "") {
        this.FilterText += "&Tamamlananharic=" + this.Filter.Tamamlananharic
      }
      if (this.Filter.Tahminibitisbas != null && this.Filter.Tahminibitisbas != "") {
        this.FilterText += "&Tahminibitisbas=" + this.Filter.Tahminibitisbas
      }
      if (this.Filter.Tahminibitisbit != null && this.Filter.Tahminibitisbit != "") {
        this.FilterText += "&Tahminibitisbit=" + this.Filter.Tahminibitisbit
      }
      

      this.ActionsFilterGet({
        Service: "tlptalep",
        Page: this.Page,
        Filter: this.FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    goToDetailPage(Id) { 
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 

    },
    BildirimGonder(){ 
      this.BildirimButton = true
      if(this.FormDataMail.To && this.FormDataMail.Subject && this.FormDataMail.Body){
        
        this.Post(JSON.parse(localStorage.getItem("config")).API_ACCOUNT_URL + "Account/mail-send", {
          
        To: this.FormDataMail.To,
        Subject: this.FormDataMail.Subject,
        Body: this.BiletListesi() +" <br> " + this.FormDataMail.Body

        },"Mail Gönderildi").then((res) => {
          if (res) {
              this.ModalOpen = false 
              this.FormDataMail.Subject  = null
              this.FormDataMail.Body  = null
          }
          this.BildirimButton = false
        })
      }
      else{
        
        this.$toast.error("Kime, Konu ve Mesaj Alanını Doldurun");
      }
    },
    BiletListesi(){
      var BiletListesi = null
      for (let index = 0; index < this.TableData.length; index++) {
        const element = this.TableData[index];
        if(BiletListesi){
          BiletListesi += ' , <br> <a href="' + window.location.origin  + '/talepdetail/' + element.Id + '" >' + element.Takipno + ' - ' + element.Baslik +  '</a>'
        }
        else{
          BiletListesi = '<a href="' + window.location.origin  + '/talepdetail/' + element.Id + '" >' + element.Takipno + ' - ' + element.Baslik + '</a>'
        }
        
      }
      return BiletListesi

    },
    

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"> 
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row"> 

                        <b-form-group class="col-lg-3" label="Başlık"  >
                            <b-form-input  v-model="Filter.Baslik"   type="text"  @keyup.enter="Page.PageNumber = 1, Get()"  ></b-form-input>
                            </b-form-group>
                          <b-form-group class="col-lg-3" label="Açıklama"  >
                            <b-form-input  v-model="Filter.Aciklama"   type="text"  @keyup.enter="Page.PageNumber = 1, Get()"  ></b-form-input>
                            </b-form-group>
                            
                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Olusturanid.FieldTitle"
                          :key="Filter.Olusturanid">
                          <treeselect :multiple="false" :options="FormDataType.Olusturanid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Olusturanid" />
                          <treeselect-value :value="Filter.Olusturanid" />
                        </b-form-group>


                        <b-form-group class="col-lg-3" label-for="text" label="Talep Sahibi Birimi"
                          :key="Filter.Atananbirimid">
                          <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Talepsahibibirimid" />
                          <treeselect-value :value="Filter.Talepsahibibirimid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Taleptipid.FieldTitle"
                          :key="Filter.Taleptipid">
                          <treeselect :multiple="false" :options="FormDataType.Taleptipid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Taleptipid" />
                          <treeselect-value :value="Filter.Taleptipid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" v-if="APPLICATION_TYPE == 1"
                          :label="FormDataType.Uygulamaid.FieldTitle" :key="Filter.Uygulamaid">
                          <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Uygulamaid" />
                          <treeselect-value :value="Filter.Uygulamaid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Destekoncelikid.FieldTitle"
                          :key="Filter.Destekoncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Destekoncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Destekoncelikid" />
                          <treeselect-value :value="Filter.Destekoncelikid" />
                        </b-form-group>


                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                          :key="Filter.Atananbirimid">
                          <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananbirimid" />
                          <treeselect-value :value="Filter.Atananbirimid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text"
                          :label="FormDataType.Atananpersonelid.FieldTitle" :key="Filter.Atananpersonelid">
                          <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananpersonelid" />
                          <treeselect-value :value="Filter.Atananpersonelid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text"
                          :label="FormDataType.Atanantemsilciid.FieldTitle" :key="Filter.Atanantemsilciid">
                          <treeselect :multiple="false" :options="FormDataType.Atanantemsilciid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atanantemsilciid" />
                          <treeselect-value :value="Filter.Atanantemsilciid" />
                        </b-form-group>


                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                          :key="Filter.Durumid">
                          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Durumid" />
                          <treeselect-value :value="Filter.Durumid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Tahmini Bitiş Tarihi Başlangıç">
                          <b-form-input v-model="Filter.Tahminibitisba" type="date"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Tahmini Bitiş Tarihi Bitiş">
                          <b-form-input v-model="Filter.Tahminibitisbit" type="date"></b-form-input>
                        </b-form-group>


                        <b-form-group class="col-lg-3" label="Oluşturma Tarihi Başlangıç">
                          <b-form-input v-model="Filter.Olusturmatarihibas" type="date"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Oluşturma Tarihi Bitiş">
                          <b-form-input v-model="Filter.Olusturmatarihibit" type="date"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Güncelleme Tarihi Başlangıç">
                          <b-form-input v-model="Filter.Guncellemetarihibas" type="date"></b-form-input>
                        </b-form-group>
                        <b-form-group class="col-lg-3" label="Güncelleme Tarihi Bitiş">
                          <b-form-input v-model="Filter.Guncellemetarihibit" type="date"></b-form-input>
                        </b-form-group>

                        <b-form-group  class="col-lg-1" v-if="APPLICATION_TYPE == 1"
                              label="Ücretli" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Ucretli" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>

                            <b-form-group  class="col-lg-2"
                              label="Tamamlananalar Hariç" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Tamamlananharic" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>


                        <div class="col-lg-3 mt-3">
                          <button class="btn btn-success  " data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Page.PageNumber = 1, Get()">
                            Filtreleme
                          </button>

                          <b-dropdown variant="success" class="btn  btn-rounded   me-2">
                            <template v-slot:button-content>
                              <i class="mdi mdi-file-export-outline me-1"></i>Yazdır <i
                                class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptalepdurum', FileFormat: 'xlsx', Filter: FilterText })">Excel</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptalepdurum', FileFormat: 'pdf', Filter: FilterText })">Pdf</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptalepdurum', FileFormat: 'docx', Filter: FilterText })">Word</b-dropdown-item>
                          </b-dropdown>
                     

                        
                        <button class="btn btn-info  " data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="ModalOpen = true">
                            Mail Gönder
                          </button>
                        </div>
 
                        <b-form-group  class="col-lg-1 text-end"
                              label="Kayıt Sayısı" 
                            >
                            <select
                                  v-model="Page.PageSize" 
                                  class="form-select" 
                                  @change="Get()"
                                >
                                  <option value="10"  >10</option>
                                  <option value="20"  >20</option>
                                  <option value="50"  >50</option>
                                  <option value="100"  >100</option>
                                  <option value="1000"  >1000</option> 
                                </select>
                            </b-form-group>


                      </div>


                    </div>
                  </div>
                </div>
              </div>

              
              <b-modal v-model="ModalOpen"   title="Mail Gönder"   hide-footer>
                <Form @submit.prevent="BildirimGonder"  >  
 
 
                  <b-form-group class="col-lg-12" label-for="text" label="Kime" >
                          <treeselect :multiple="false" :options="FormDataType.Olusturanid.ComboDataArray2"
                            placeholder="Seçiniz..." v-model="FormDataMail.To" />
                          <treeselect-value :value="FormDataMail.To" />
                  </b-form-group>


                  <b-form-group class="col-lg-12" label="Konu"  >
                        <input class="form-control" v-model="FormDataMail.Subject"   type="text" /> 
                  </b-form-group> 
              
                  <b-form-group class="col-lg-12" label="Mesaj"  >
                   <span v-html="BiletListesi()">  </span>
                        <textarea class="form-control" v-model="FormDataMail.Body"   type="text" ></textarea> 
                  </b-form-group> 
              
                  <button class="btn btn-primary" type="submit" :disabled="BildirimButton">
                    Gönder
                  </button>
                </Form>
              </b-modal>


              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                    <tableheader  @OrderBy="Filter.OrderBy = $event , Get()" :Data='APPLICATION_TYPE == 1 ? [
                        { "Takipno": "Takip No" },
                        { "Baslik": "Başlık" },
                        { "Uygulama": "Uygulama" },
                        { "Olusturan": "Talep Sahibi" },
                        { "Talepsahibibirim": "Talep Sahibi Birim" },
                        { "Taleptip": "Talep Tipi" },
                        { "Durum": "Durum" },
                        { "Oncelik": "Öncelik" },
                        { "Destekoncelik": "Destek Öncelik" },
                        { "Atananbirim": "Atanan Birim" },
                        { "Atananpersonel": "Atanan Personel" },
                        { "Atanantemsilci": "Atanan Temsilci" },
                        { "Isgucu": "İş Gücü" },
                        { "Harcananzaman": "Harcanan Zaman" },
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" },
                        { "Created": "Oluşturma Tarihi" },
                        { "Lastmodified": "Güncelleme Tarihi" }, 
                        { "": "İşlem" },
                      ] : 
                      [
                        { "Takipno": "Takip No" },
                        { "Baslik": "Başlık" }, 
                        { "Olusturan": "Talep Sahibi" },
                        { "Talepsahibibirim": "Talep Sahibi Birim" },
                        { "Taleptip": "Talep Tipi" },
                        { "Durum": "Durum" },
                        { "Oncelik": "Öncelik" },
                        { "Destekoncelik": "Destek Öncelik" },
                        { "Atananbirim": "Atanan Birim" },
                        { "Atananpersonel": "Atanan Personel" },
                        { "Atanantemsilci": "Atanan Temsilci" },
                        { "Isgucu": "İş Gücü" },
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" },
                        { "Created": "Oluşturma Tarihi" },
                        { "Lastmodified": "Güncelleme Tarihi" }, 
                        { "": "İşlem" },
                      ]' /> 
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Uygulama }}</td>
                      <td>{{ Data.Olusturan }}</td>
                      <td>{{ Data.Talepsahibibirim }}</td>
                      <td>{{ Data.Taleptip }}</td>
                      <td :class="DurumRenklendirme(Data.Durum)">{{ Data.Durum }}</td>
                      <td :class="OncelikRenklendirme(Data.Oncelik)">{{ Data.Oncelik }}</td>
                      <td :class="OncelikRenklendirme(Data.Destekoncelik)">{{ Data.Destekoncelik }}</td> 
                      <td>{{ Data.Atananbirim }}</td>
                      <td>{{ Data.Atananpersonel }}</td>
                      <td>{{ Data.Atanantemsilci }}</td>
                      <td>{{ Data.Isgucu }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Harcananzaman }}</td>
                      <td>{{ Data.Tahminibitis != null ? formatDateTable(Data.Tahminibitis) : '' }}</td>
                      <td>{{ Data.Created != null ? formatDateTable(Data.Created) : '' }}</td>
                      <td>{{ Data.Lastmodified != null ? formatDateTable(Data.Lastmodified) : '' }}</td>
                      <td>
                         
                        <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>

                      </td>

                    </tr>
                  </tbody>
                </table>
                <br /><b>Toplam Kayıt Sayısı: {{ Page.PageDataSize }}</b>
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"   
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Layout>
  </Loader>
</template>
